export const templateOfAccordionOneRowBlock = `
    <div class="row content-block">
        <div class="col-12 column px-8 py-0 accordion accordion-one-row">
            <details class="details-accordion">
                <summary class="summary-accordion"><strong>Example title</strong></summary>
                <div class="content-accordion" data-type="detailsContent">
                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
                </div>
            </details>
        </div>
    </div>
`